module.exports = __webpack_public_path__ + "img/asian-starters-1.fa749efb.jpg";